import { types, flow } from 'mobx-state-tree';
import InboxItemModel from './InboxItemModel';
import UserModel from '../UserModel';
import getUnreadCountQ from './getUnreadCountQ.graphql';
import {
  query,
  restFetcher,
} from '../../core/createApolloClient/createApolloClient.client';
import { getp } from '../../helpers/getProp';
import _ from 'lodash';
import InboxSummarySampleData from './InboxSummarySampleData';
import fetch from 'cross-fetch';
//   t.id,
//   t.reservationId,
//   t.listId,
//   t.hostId,
//   t.guestId,
//   t.updatedAt,
//   r.checkIn,
//   r.checkOut,
//   r.reservationState,
//   l.title,
//   l.city,
//   l.state;

const FocusedType = types
  .model('FocusedTypeModel', {
    id: 0,
    isExchange: types.optional(types.boolean, false),
    item: types.maybeNull(types.reference(InboxItemModel)),
    viewChat: false,
  })
  .actions(self => ({
    seeChat: () => {
      self.viewChat = true;
    },
  }));

export default types
  .model('InboxModel', {
    approved: types.array(InboxItemModel),
    pending: types.array(InboxItemModel),
    inquiries: types.array(InboxItemModel),
    completed: types.array(InboxItemModel),
    exchanges: types.array(InboxItemModel),
    unreadCount: types.number,
    currentUser: UserModel,
    loaded: false,
    intervalId: 0,
    focused: types.maybeNull(FocusedType),
  })
  .actions(self => ({
    // UNREAD COUNT
    startCountPolling: () => {
      self.getUnreadCount();
      if (!self.intervalId) {
        self.intervalId = setInterval(self.getUnreadCount, 60000);
      }
      // Doesn't need to be killed because it lives with the app and dies with the app.
    },
    getUnreadCount: noUpdateSummary => {
      if (!self.currentUser.id) return;
      
      query(
        getUnreadCountQ,
        {},
        {
          fetchPolicy: 'network-only',
        },
      )
        .then(res => self.handleMessageCount(res, noUpdateSummary))
        .catch(err =>
          console.log('InboxModel.js - MessageCount GET - failed', err),
        );
    },
    handleMessageCount: (res, noUpdateSummary) => {
      const total = getp(res, 'data.getUnreadCount.total');
      console.log('InboxModel.js messageCount', total);
      if (total && total !== self.unreadCount) {
        self.unreadCount = total;
        if (!noUpdateSummary) {
          self.updateSummary();
        }
      }
    },
    readItem: () => {
      self.unreadCount -= 1;
    },
    // SUMMARIES
    updateSummary: async () => {
      // if (InboxSummarySampleData) {
      //   self.processSummary(inboxSummarySampleData);
      //   return;
      // }
      if (!self.isOnInbox) {
        console.log('Summary updates paused');
        return;
      }
      console.log('Summary updating summary');
      const res = await restFetcher('GET', '/api/inboxSummary');
      self.processSummary(res);
    },
    processSummary: res => {
      self.approved = res.data.approved.map(x => buildInboxItem(x, self));
      self.pending = res.data.pending.map(x => buildInboxItem(x, self));
      self.inquiries = res.data.inquiries.map(x => buildInboxItem(x, self));
      self.completed = res.data.completed.map(x => buildInboxItem(x, self));
      self.exchanges = res.data.exchanges.map(x => buildInboxItem(x, self));
    },
    // READING MESSAGES
    loadItem: flow(function*(item) {
      const isRead = yield item.load();
      if (isRead) {
        self.getUnreadCount(true);
      }
      return isRead;
    }),
    setFocused(id, item, isExchange) {
      if (id === null) {
        self.focused = null;
      } else {
        self.focused = {
          id,
          item,
          isExchange,
        };

        if (id && !item) {
          // Go get item
        }
      }
    },
  }))
  .views(self => ({
    get approvedUnreadCount() {
      return self.approved.filter(x => x.isUnread).length;
    },
    get pendingUnreadCount() {
      return self.pending.filter(x => x.isUnread).length;
    },
    get inquiriesUnreadCount() {
      return self.inquiries.filter(x => x.isUnread).length;
    },
    get completedUnreadCount() {
      return self.completed.filter(x => x.isUnread).length;
    },
    get exchangesUnreadCount() {
      return self.exchanges.filter(x => x.isUnread).length;
    },
    get isOnInbox() {
      if (window && window.location.pathname.indexOf('inbox') < 0) {
        return false;
      } else if (!window) {
        return false;
      }
      return true;
    },
  }));

function buildInboxItem(serverData, inbox) {
  const toAdd = {};
  _.forEach(serverData, (v, k) => {
    if (v !== null && v !== undefined) {
      let next = v;
      if (k === 'threadId' || k === 'reservationId' || k === 'listId') {
        next = +v;
      }
      toAdd[k] = next;
    }
  });
  toAdd.isPickup = !serverData.pickupCompleted;

  return InboxItemModel.create(toAdd);
}


// WEBPACK FOOTER //
// ./src/mobxStores/Inbox/InboxModel.js